import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/brand.css';
import App from './app/App';
import PaymentRoute from './pages/Payment/PaymentRoute';
import SupportDialog from './pages/SupportDialog/SupportDialog';
import OrderAnnounce from './pages/OrderAnnounce/OrderAnnounce';
import CalendarDownload from './pages/CalendarDownload/CalendarDownload';

import { ChecklistProvider } from './context/ChecklistContext';
import RepeatOrder from "./pages/RepeatOrder";
import Rating from './pages/Rating/Rating';
import CommReply from './pages/CommReply/CommReply';
import BuyPackage from './pages/BuyPackage';
import OrderOptions from './pages/OrderOptions';
import CleanerSchedule from './pages/CleanerSchedule';
import SuccessPayment from './pages/SuccessPayment';
import OpenOrder from './pages/OpenOrder/OpenOrder';
import OpenSchedule from './pages/OpenSchedule/OpenSchedule';
import BliqConfirm from './pages/BliqConfirm/BliqConfirm';
import BliqConsent from './pages/BliqConsent/BliqConsent';
import DataConsent from './pages/DataConsent/DataConsent';
import BetaFeedback from './pages/BetaFeedback/BetaFeedback';


const root = createRoot(document.getElementById('root'));

root.render(
    <Router>
        <Routes>
            {/* Чеклист с провайдером */}
            <Route
                path="/checklist/*"
                element={
                    <ChecklistProvider>
                        <App />
                    </ChecklistProvider>
                }
            />
            {/* Страница оплаты (PaymentRoute): любая ссылка, которую принимает парсер paymentSubject.js -> EveryPay.
                Ответ ws5 not_available для order/completed/tip -> откат на legacy Montonio с суффиксным id.
                Id, который парсер не принял -> legacy Montonio (его экран ошибки). */}
            <Route path="/external/payment/:lang/:orderId" element={<PaymentRoute />} />

            {/* Покупка пакета */}
            <Route path="/external/buy-package/:lang?" element={<BuyPackage />} />

            {/* Изменение опций существующего заказа */}
            <Route path="/external/order-options/:lang?" element={<OrderOptions />} />

            {/* Возврат после платежа Montonio (returnUrl) */}
            <Route path="/external/success-payment/:lang?" element={<SuccessPayment />} />

            {/* Прибытие на заказ */}
            <Route path="/cleaner/order-announce/:orderId" element={<OrderAnnounce />} />

            {/* Расписание клинера */}
            <Route path="/cleaner/schedule" element={<CleanerSchedule />} />

            {/* Открыть заказ в приложении клинера (кнопка из Telegram-уведомления) */}
            <Route path="/cleaner/open-order/:id" element={<OpenOrder />} />

            {/* Открыть расписание клинера на конкретный день (кнопка из Telegram-уведомления) */}
            <Route path="/cleaner/open-schedule" element={<OpenSchedule />} />

            {/* Intercom */}
            <Route path="/support/dialog/:userId?" element={<SupportDialog />} />

            {/* Повтор заказа */}
            <Route path="/internal/repeat_order/:lang/:orderId" element={<RepeatOrder />} />

            {/* Рейтинг для  заказа */}
            <Route path="/internal/rating/:lang/:orderId" element={<Rating />} />

            {/* Ответ клиента на коммуникацию клинера (из email-кнопок) */}
            <Route path="/external/comm-reply/:lang/:orderId" element={<CommReply />} />

            {/* Обратная связь по бете клиентского приложения (ссылка из email, :userId = Users recid) */}
            <Route path="/external/beta-feedback/:lang/:userId" element={<BetaFeedback />} />

            {/* Скачивание календаря */}
            <Route path="/internal/calendar/:lang/:orderId" element={<CalendarDownload />} />

            {/* Bliq: подтверждение перевозки менеджером Bliq (из письма) */}
            <Route path="/external/bliq-confirm/:token" element={<BliqConfirm />} />

            {/* Bliq: согласие клиента на демо-поездку (EN/ET) */}
            <Route path="/external/bliq-consent/:lang/:token" element={<BliqConsent />} />
            {/* Bliq: 1-tap решение из кнопки письма/WhatsApp (agree|decline) */}
            <Route path="/external/bliq-consent/:lang/:token/:decision" element={<BliqConsent />} />

            {/* Согласие клиента на программу записи (robotics data), ссылку шлёт саппорт из админки */}
            <Route path="/internal/data-consent/:lang/:orderId" element={<DataConsent />} />

            {/* Заглушка для неправильных маршрутов */}
            <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
    </Router>
);

